export default __webpack_public_path__ + "static/media/logo.6663ba27.png";